export const CustomPlace: string = "[CUSTOM]"
